import { createApiAction } from '@app/packages/api/utils'
import type { ApiParentProfile, ApiSitterProfile } from '@app/packages/api/v2/types/entities'
import type { ApiDataResponse } from '@app/packages/api/v2/types/misc'

export const postTOSAcceptance = () =>
  createApiAction('postTOSAcceptance', dispatch =>
    dispatch<ApiDataResponse<ApiParentProfile | ApiSitterProfile>>({ method: 'POST', endpoint: '/api/v2/tos/acceptance' })
  )
